import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesFieldEditRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-field-edit',
	path: '/secure/admin/EditFieldScreen!default.jspa',
};
